import "./LocationsFilter.scss";
import FilterTypeMenu from "@/components/Common/FilterTypeMenu/FilterTypeMenu.vue";

export default {
  name: "LocationsFilter",
  props: ["districts", "states", "countries", "deleted", "value"],
  components: { FilterTypeMenu },
  data: () => ({
    dialog: false,
    selectedCountry: [],
    selectedDistrict: [],
    selectedState: []
  }),
  mounted() {},
  methods: {
    resetFilter() {
      this.$emit("resetFilter");
      this.dialog = false;
    },
    filter() {
      this.$emit("filter");
      this.dialog = false;
    },
    setCountry(country) {
      if (!country?._id) {
        this.value.country = "";
        this.selectedCountry = [];
        return;
      }
      if (this.value.country === country._id) {
        this.value.country = "";
        this.selectedCountry = [];
        return;
      } else {
        this.value.country = country._id;
        this.selectedCountry = [country._id];
      }

      this.selectedCountry.reverse().reverse();
      this.$emit("filter");
    },
    setDistrict(district) {
      if (!district?._id) {
        this.value.district = "";
        return;
      }
      if (district._id === this.value.district) {
        this.value.district = "";
        this.selectedDistrict = [];
        return;
      } else {
        this.value.district = district._id;
        this.selectedDistrict = [district._id];
      }

      this.selectedDistrict.reverse().reverse();
      this.$emit("filter");
    },
    setState(state) {
      if (!state?._id) {
        this.value.state = "";
        return;
      }
      if (state._id === this.value.state) {
        this.value.state = "";
        this.selectedState = [];
        return;
      } else {
        this.value.state = state._id;
        this.selectedState = [state._id];
      }

      this.selectedState.reverse().reverse();
      this.$emit("filter");
    }
  },
  computed: {
    deletedComputed: {
      get() {
        return this.deleted;
      },
      set(value) {
        this.$emit("updateDeleted");
        this.$emit("filter");
      }
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  }
};
